import React from 'react';
import { Button } from '@/components/common';
import type { AppNotification } from '../../types';
import { buildNotificationRoute } from '../../utils/notification-routing';

interface Props {
  notification: AppNotification;
  onNavigate?: (path: string) => void;
}

export const EventCreatedCard: React.FC<Props> = ({ notification, onNavigate }) => {
  const handleClick = () => {
    const route = buildNotificationRoute(notification);
    if (route) onNavigate?.(route);
  };

  return (
    <Button onClick={handleClick} variant="plain" size="none" className="text-left w-full justify-start">
      {notification.body ? <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{notification.body}</p> : null}
    </Button>
  );
};
